// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Layout-module--arrow-up-and-down--ef7c3";
export var container = "Layout-module--container--f70fd";
export var headerWithOpaqueBackground = "Layout-module--headerWithOpaqueBackground--bcde6";
export var main = "Layout-module--main--8841c";